import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);

export const fetchSchema = () => {
    return axios.get('/api/v1/notifications/schema/');
};

export const fetchNotifications = (params) => {
    return axios.get('/api/v1/notifications/', { params });
};

export const updateNotifications = (data) => {
    return axios.post('/api/v1/notifications/change_state_batch/', data);
};
